import script from "./DhVNodes.vue?vue&type=script&lang=ts"
export * from "./DhVNodes.vue?vue&type=script&lang=ts"

export default script